import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function Tickets() {
    return (
        <div id="wrapper">
            {/* Header component */}
            <Header />

            <div className="no-bottom no-top" id="content">
                <div id="top"></div>

                {/* section begin */}
                <section id="subheader" className="minimal">
                    <div className="center-y relative text-center">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    <h1>Tickets NFT</h1>
                                </div>
                                <div className="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* section close */}

                {/* section begin */}
                <section aria-label="section" style={{ paddingTop: 0 }}>
                    <div className="container">
                        <div className="row justify-content-center text-center wow fadeIn">

                            <div className="col-lg-9 col-md-10">
                                <div className="post-image-single">
                                    <img src="https://nftcrypto.io/wp-content/uploads/2023/09/2023-09-28-11_07_36-Window.png" className="d-banner-img-edit img-fluid" />
                                </div>

                                <div className="post-body text-left" style={{ fontSize: '18px', lineHeight: '1.8', color: '#000' }}>

                                    <p>Gallery3 NFT tickets are digital passes stored securely on the blockchain, offering an innovative way to access exclusive art gallery events—think exhibition openings, private viewings, and artist talks. Unlike traditional tickets, our NFTs are unique, forgery-proof, and designed as stunning digital artworks, doubling as functional passes and collectible keepsakes. Managed effortlessly through digital wallets, they streamline the ticketing process while elevating the patron experience.</p>
                                    <p>Imagine hosting an exclusive opening at your gallery. With Gallery3, you issue NFT tickets that grant secure entry while showcasing artwork from the event's featured artist. Patrons enjoy VIP perks like a private artist talk, and afterward, they keep their ticket as a digital collectible. </p>
                                </div>


                                <div id="section-intro" class="no-bottom pt60">
                                    <div class="container">
                                        <div class="row">
                                            <div className="col-lg-12">
                                                <div className="text-center">
                                                    <h1>How it works</h1>
                                                    <div className="small-border bg-color-2"></div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 mb-sm-30">
                                                <div className="de-card-icon">
                                                    <i className="wow fadeInUp bg-color-2 i-boxed icon_wallet"></i>
                                                    <div className="text">
                                                        <h4 className="wow fadeInUp" data-wow-delay=".15s">1. Partner with Gallery3</h4>
                                                        <p className="wow fadeInUp" data-wow-delay=".25s">Connect your wallet and verify your account. Easily integrate your upcoming exhibitions and events. Receive personalized support from our team to ensure a smooth setup.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 mb-sm-30">
                                                <div className="de-card-icon">
                                                    <i className="wow fadeInUp bg-color-2 i-boxed icon_tags_alt"></i>
                                                    <div className="text">
                                                        <h4 className="wow fadeInUp" data-wow-delay=".15s">2. Create your NFT tickets</h4>
                                                        <p className="wow fadeInUp" data-wow-delay=".25s">Customize with our team design and ticket features to offer exclusive access and benefits to your patrons. Determine the quantity and pricing for your event.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 mb-sm-30">
                                                <div className="de-card-icon">
                                                    <i className="wow fadeInUp bg-color-2 i-boxed icon_cloud-upload_alt "></i>
                                                    <div className="text">
                                                        <h4 className="wow fadeInUp" data-wow-delay=".15s">3. Launch and Connect</h4>
                                                        <p className="wow fadeInUp" data-wow-delay=".25s">Sell your NFT tickets through our secure marketplace, track ticket sales and and engage with your audience like never before, building a community around your gallery.</p>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>


                                <div className="text-center pt60">
                                    <h1>Why choose Gallery3 NFT tickets?</h1>
                                    <div className="small-border bg-color-2"></div>
                                </div>
                                <div className="p-points">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6 col-sm-12 mb-4">
                                            <div className="feature-box" style={{ textAlign: 'left' }}>
                                                <div className="feature-box-content">
                                                    <h4>Unmatched Security</h4>
                                                    <p>With blockchain technology, Gallery3 eliminates counterfeit risks. Every ticket's authenticity is guaranteed, ensuring only legitimate holders gain entry to your high-demand events.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 mb-4">
                                            <div className="feature-box" style={{ textAlign: 'left' }}>
                                                <div className="feature-box-content">
                                                    <h4>Artistic Collectibles</h4>
                                                    <p>Each NFT ticket is a unique digital artwork, crafted by featured artists or inspired by your exhibitions. Patrons can build a digital collection that celebrates their gallery visits, adding lasting value.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 mb-4">
                                            <div className="feature-box" style={{ textAlign: 'left' }}>
                                                <div className="feature-box-content">
                                                    <h4>Exclusive Patron Perks</h4>
                                                    <p>Enhance engagement with special benefits—early access, private events, or digital extras like virtual tours. Our smart contracts let you add perks dynamically, creating personalized experiences.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 mb-4">
                                            <div className="feature-box" style={{ textAlign: 'left' }}>
                                                <div className="feature-box-content">
                                                    <h4>Community Connection</h4>
                                                    <p>Build lasting relationships with your audience. Gallery3's on-chain insights help you understand patron preferences, fostering a vibrant community akin to a membership program.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 pt0">

                                            <a href="mailto:tickets@gallery3.xyz" className="btn-main btn-lg">→ Contact us to create your Ticket NFTs</a>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>


                    </div>




                </section>




            </div>

            {/* Footer */}
            < Footer />
        </div >
    );
}

export default Tickets;